import { ReceiptType, ReceiptTypeCodes } from '@checkout-v2/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomCheckoutState, StateWithCustomCheckout } from '../checkout-state';
import { getActiveModes } from './checkout.selector';
import { getCustomCheckoutState } from './feature.selector';

export const getReceiptTypes: MemoizedSelector<StateWithCustomCheckout, ReceiptType[]> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderValueSelector(state.receiptTypes),
);

export const getActiveReceiptType: MemoizedSelector<StateWithCustomCheckout, ReceiptTypeCodes | undefined> =
  createSelector(getActiveModes, (activeModes) => activeModes.receiptType);
